const RichText = ({ segments }) => {
    return (
        <p
            style={{
                textAlign: "left",
                marginBottom: 0,
                marginTop: 16,
            }}
            className="card-content"
        >
            {segments.map((segment) =>
                segment.bold ? (
                    <strong key={segment.text}>{segment.text}</strong>
                ) : (
                    <span key={segment.text}>{segment.text}</span>
                )
            )}
        </p>
    );
};

export default RichText;
